module.exports = __webpack_public_path__ + "static/media/SarahSwitek_03_HowAreYouFeeling-Confirmation_1.84c2b687.mp3";